import { hasAllSameDigits, isValidPhone } from './helpers';

/**
 * Controllo di plausibilità lato client per un numero italiano.
 * Non verifica che il numero esista.
 */
export function isPlausibleItalianPhone(phone: string): boolean {
  const digits = phone.replace(/\D/g, '');
  const mobile = /^3\d{9}$/.test(digits);
  const landline = /^0\d{5,10}$/.test(digits);
  if (!mobile && !landline) return false;
  if (/^(\d)\1+$/.test(digits)) return false;
  if (isSequential(digits)) return false;
  return true;
}

function isSequential(digits: string): boolean {
  if (digits.length < 6) return false;
  let ascending = true;
  let descending = true;
  for (let index = 1; index < digits.length; index += 1) {
    const diff = Number(digits[index]) - Number(digits[index - 1]);
    if (diff !== 1) ascending = false;
    if (diff !== -1) descending = false;
  }
  return ascending || descending;
}

export function prefixError(prefix: string): string {
  const compact = prefix.replace(/\s/g, '');
  if (!compact) return 'Prefisso obbligatorio';
  if (!compact.startsWith('+')) return 'Il prefisso deve iniziare con +';
  if (!/^\+\d{1,4}$/.test(compact)) return 'Prefisso non valido';
  return '';
}

export function nationalPhoneError(prefix: string, national: string): string {
  if (!national.trim()) return 'Campo obbligatorio';

  const digits = national.replace(/\D/g, '');
  if (hasAllSameDigits(digits)) {
    return 'Il numero non può avere tutte le cifre uguali.';
  }

  const compactPrefix = prefix.replace(/\s/g, '');
  if (compactPrefix === '+39') {
    if (!isValidPhone(digits)) return 'Numero di telefono non valido';
    if (!isPlausibleItalianPhone(digits)) return 'Inserisci un numero di telefono italiano valido';
    return '';
  }

  if (!/^\d{6,14}$/.test(digits)) return 'Numero di telefono non valido';
  const total = compactPrefix.replace(/\D/g, '').length + digits.length;
  if (total < 8 || total > 15) return 'Numero di telefono non valido';
  return '';
}

/** Prefisso + numero nazionale, un solo + e senza spazi. */
export function composePhone(prefix: string, national: string): string {
  const prefixDigits = prefix.replace(/\D/g, '').slice(0, 4);
  let digits = national.replace(/\D/g, '');

  if (prefixDigits === '39' && digits.startsWith('39') && digits.length > 10) {
    const rest = digits.slice(2);
    if (rest.length >= 6) digits = rest;
  }

  return prefixDigits ? `+${prefixDigits}${digits}` : digits;
}

/** Se l'utente incolla un numero internazionale, tiene solo la parte nazionale. */
export function nationalFromInput(raw: string, prefix: string): string {
  const trimmed = raw.trim();
  const looksInternational = trimmed.startsWith('+') || trimmed.startsWith('00');
  if (!looksInternational) {
    return raw.replace(/[^\d\s]/g, '');
  }

  let digits = trimmed.replace(/\D/g, '');
  if (digits.startsWith('00')) digits = digits.slice(2);
  const prefixDigits = prefix.replace(/\D/g, '');
  if (prefixDigits && digits.startsWith(prefixDigits) && digits.length > prefixDigits.length) {
    return digits.slice(prefixDigits.length);
  }
  return digits;
}
